/*
Mirrors the type-verb template keys in b2b-api/app/controllers/templates/notifications.js
in Bahasa Indonesia. Keep this file's keys in sync whenever that backend file changes.
*/

const id = {
  'order-approval': (n) =>
    `Sales order baru sedang menunggu persetujuan dari ${n.object?.salesman}`,
  'customer_registration-need_approval': (n) =>
    `Pelanggan ${n.object?.message} untuk ${n.object?.name} menunggu persetujuan`,
  'customer_registration-approved': (n) =>
    `Pelanggan ${n.object?.message} untuk ${n.object?.name} telah disetujui oleh ${n.object?.role}`,
  'customer_registration-rejected': (n) =>
    `Pelanggan ${n.object?.message} untuk ${n.object?.name} telah ditolak oleh ${n.object?.role}`,
  'price_rules-approval': (n) =>
    `Pricelist untuk ${n.object?.name} sedang menunggu persetujuan`,
  'price_rules-approved': (n) =>
    `Pricelist untuk ${n.object?.name} telah disetujui`,
  'price_rules-rejected': (n) =>
    `Pricelist untuk ${n.object?.name} telah ditolak`,
  'orders-approval': (n) =>
    `Sales Order #${n.object?.orderId} sedang menunggu persetujuan`,
  'orders-approved': (n) => `Sales Order #${n.object?.orderId} telah disetujui`,
  'orders-cancelled': (n) =>
    `Sales Order #${n.object?.orderId} telah dibatalkan`,
  'orders-rejected': (n) => `Sales Order #${n.object?.orderId} telah ditolak`,
  'activities-approval': (n) =>
    `Konfirmasi rencana aktivitas untuk ${n.object?.name}`,
  'activities-approved': (n) => `${n.object?.title} telah disetujui`,
  'activities-rejected': (n) => `${n.object?.title} telah ditolak`,
  'loyalty_points-confirmation': (n) =>
    `Konfirmasi poin loyalti ${n.object?.action} untuk ${n.object?.customer_name}`,
  'loyalty_points-approved': (n) =>
    `Poin loyalti ${n.object?.action} untuk ${n.object?.customer_name} telah disetujui`,
  'loyalty_points-rejected': (n) =>
    `Poin loyalti ${n.object?.action} untuk ${n.object?.customer_name} telah ditolak`,
  'customers_clusters-need_approval': (n) =>
    `Persetujuan klaster pelanggan ${n.object?.customer_name} sedang menunggu`,
  'customers_clusters-approved': (n) =>
    `Persetujuan klaster pelanggan ${n.object?.customer_name} telah disetujui oleh ${n.object?.role}`,
  'customers_clusters-rejected': (n) =>
    `Persetujuan klaster pelanggan ${n.object?.customer_name} telah ditolak oleh ${n.object?.role}`,
  'activity-assignment': (n) =>
    `${n.object?.title} | ${n.object?.name} menugaskan aktivitas baru untuk Anda`,
  'customer_limit_update-need_approval': (n) =>
    `Pelanggan ${n.object?.name} sedang menunggu persetujuan`,
  'customer_limit_update-approved': (n) =>
    `Pelanggan ${n.object?.name} telah disetujui oleh ${n.object?.role}`,
  'customer_limit_update-rejected': (n) =>
    `Pelanggan ${n.object?.name} telah ditolak oleh ${n.object?.role}`,
  'budget-pockets-approval': (n) =>
    `Konfirmasi budget pocket untuk ${n.object?.name}`,
  'budget-pockets-approved': (n) =>
    `Budget Pocket untuk ${n.object?.title} telah disetujui`,
  'budget-pockets-rejected': (n) =>
    `Budget Pocket untuk ${n.object?.title} telah ditolak`,
  'target-settings-approval': (n) =>
    `Konfirmasi target settings untuk ${n.object?.name}`,
  'target-settings-approved': (n) => `${n.object?.target_type} telah disetujui`,
  'target-settings-rejected': (n) => `${n.object?.target_type} telah ditolak`,
  'promotion-rules-approval': (n) =>
    `Konfirmasi promotion rules untuk ${n.object?.name}`,
  'promotion-rules-approved': (n) => `${n.object?.title} telah disetujui`,
  'promotion-rules-rejected': (n) => `${n.object?.title} telah ditolak`,
  'return-orders-approval': (n) =>
    `Return Order #${n.object?.orderId} sedang menunggu persetujuan`,
  'return-orders-approved': (n) =>
    `Return Order #${n.object?.orderId} telah disetujui`,
  'return-orders-cancelled': (n) =>
    `Return Order #${n.object?.orderId} telah dibatalkan`,
  'return-orders-rejected': (n) =>
    `Return Order #${n.object?.orderId} telah ditolak`,
  'skp-internals-approval': (n) =>
    `SKP Internal #${n.object?.name} sedang menunggu persetujuan`,
  'skp-internals-approved': (n) =>
    `SKP Internal #${n.object?.title} telah disetujui`,
  'skp-internals-cancelled': (n) =>
    `SKP Internal #${n.object?.title} telah dibatalkan`,
  'skp-internals-rejected': (n) =>
    `SKP Internal #${n.object?.title} telah ditolak`,
  'skp-externals-approval': (n) =>
    `SKP External #${n.object?.reference_code} sedang menunggu persetujuan`,
  'skp-externals-approved': (n) =>
    `SKP External #${n.object?.reference_code} telah disetujui`,
  'skp-externals-cancelled': (n) =>
    `SKP External #${n.object?.reference_code} telah dibatalkan`,
  'skp-externals-rejected': (n) =>
    `SKP External #${n.object?.reference_code} telah ditolak`,
  'lpb-approval': (n) =>
    `Goods Received Note ${n.object?.do_number} sedang menunggu persetujuan`,
  'lpb-approved': (n) =>
    `Goods Received Note ${n.object?.do_number} telah disetujui`,
  'lpb-rejected': (n) =>
    `Goods Received Note ${n.object?.do_number} telah ditolak`,
  'request-product-tester-approval': (n) =>
    `Request Product Tester #${n.object?.reference_code} sedang menunggu persetujuan`,
  'request-product-tester-approved': (n) =>
    `Request Product Tester #${n.object?.reference_code} telah disetujui`,
  'request-product-tester-rejected': (n) =>
    `Request Product Tester #${n.object?.reference_code} telah ditolak`,
  'orders-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'return-orders-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'skp-internals-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'skp-externals-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'request-product-tester-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'request-product-eligibilities-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'lpb-mentioned': (n) => `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'customers-mentioned': (n) =>
    `${n.actors?.[0]?.name} menyebut Anda dalam komentar`,
  'orders-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'return-orders-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'skp-internals-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'skp-externals-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'request-product-tester-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'request-product-eligibilities-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'lpb-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'customers-edited': (n) =>
    `${n.actors?.[0]?.name} mengedit komentar yang menyebut Anda`,
  'orders-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'return-orders-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'skp-internals-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'skp-externals-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'request-product-tester-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'request-product-eligibilities-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'lpb-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
  'customers-deleted': (n) =>
    `${n.actors?.[0]?.name} menghapus komentar yang menyebut Anda`,
};

const DICTIONARIES = { id };

export const translateNotificationTitle = (notification, currentLanguage) => {
  const dictionary = DICTIONARIES[currentLanguage];
  if (!dictionary || !notification) {
    return notification?.title;
  }
  const type = notification.target_type || notification.object?.type;
  const key = `${type}-${notification.verb}`;
  const formatter = dictionary[key];
  if (!formatter) {
    return notification.title;
  }
  try {
    return formatter(notification) || notification.title;
  } catch (error) {
    return notification.title;
  }
};

export default translateNotificationTitle;
